export default __webpack_public_path__ + "static/media/navi-white.06abd503.png";